import { createSlice } from "@reduxjs/toolkit";

const designSlice = createSlice({
    name:"designs",
    initialState:{
        designs:null
    },
    reducers:{
        setDesignList(state,action){
            state.designs = action?.payload;
        },
    }
})


export const {setDesignList} = designSlice.actions
export default designSlice.reducer